// Shadow values match the shared ScrollBox so virtualised and plain scroll areas look the same.
const shadows = {
    top: 'inset -4px 16px 16px -16px rgba(0, 0, 0, 0.08)',
    bottom: 'inset -4px -16px 16px -16px rgba(0, 0, 0, 0.08)',
    left: 'inset 16px 0 16px -16px rgba(0, 0, 0, 0.08)',
    right: 'inset -16px 0 16px -16px rgba(0, 0, 0, 0.08)',
};

const shadowTransition = 'box-shadow 0.2s ease-in-out';
const shadowStripSize = 100;
const headerHeightVariable = '--virtual-table-header-height';

const topShadowClassName = 'has-top-shadow';
const bottomShadowClassName = 'has-bottom-shadow';
const leftShadowClassName = 'has-left-shadow';
const rightShadowClassName = 'has-right-shadow';

/**
 * Spread onto the row list. The strips are sticky so they drift with the rows during overscroll
 * instead of detaching from the header, and negative margins keep them out of the flow the row
 * heights rely on.
 */
const verticalShadowStrips = {
    ['&::before, &::after']: {
        content: '""',
        display: 'block',
        position: 'sticky',
        height: shadowStripSize,
        zIndex: 1,
        pointerEvents: 'none',
        transition: shadowTransition,
    },
    // Offset by the header so the shadow falls onto the rows rather than onto the header itself.
    ['&::before']: {
        top: `var(${headerHeightVariable}, 0px)`,
        marginBottom: `-${shadowStripSize}px`,
    },
    ['&::after']: {
        bottom: 0,
        marginTop: `-${shadowStripSize}px`,
    },
    [`&.${topShadowClassName}::before`]: { boxShadow: shadows.top },
    [`&.${bottomShadowClassName}::after`]: { boxShadow: shadows.bottom },
};

/**
 * Spread onto a sibling that shares the scroller's grid area. It sits outside the scroller so the
 * strips hold the viewport edges instead of scrolling away, and above it so they cross the header.
 */
const horizontalShadowOverlay = {
    position: 'relative',
    pointerEvents: 'none',
    zIndex: 3,

    ['&::before, &::after']: {
        content: '""',
        position: 'absolute',
        insetBlock: 0,
        width: shadowStripSize,
        transition: shadowTransition,
    },
    ['&::before']: { left: 0 },
    ['&::after']: { right: 0 },
    [`&.${leftShadowClassName}::before`]: { boxShadow: shadows.left },
    [`&.${rightShadowClassName}::after`]: { boxShadow: shadows.right },
};

export {
    bottomShadowClassName,
    headerHeightVariable,
    horizontalShadowOverlay,
    leftShadowClassName,
    rightShadowClassName,
    topShadowClassName,
    verticalShadowStrips,
};
